import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppShell from './AppShell';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppShell />);
